define('views/content/forgot_password',['require','views/base/item_page_view','marionette','jquery-validation','text!templates/content/forgot_password.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('marionette');
    require('jquery-validation');

    var temp = require("text!templates/content/forgot_password.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'login-wrapper',
        fullPage: true,

        submitButtonClicked: function () {
            var _this = this;

            if (this.ui.mainForm.valid()) {

                this.ui.submitButton.addClass('loading');

                this.model.save(null, {
                    success: function (model, response, options) {
                        _this.ui.submitButton.removeClass('loading');

                        App.utils.showMessage('success', App.polyglot.t('password_reset_sent'));
                        App.context.redirect('/');
                    },
                    error: function (model, response, options) {
                        _this.ui.submitButton.removeClass('loading');

                        // Show error messages
                        if (response.responseJSON.errors) {
                            for (var i=0; i<response.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', response.responseJSON.errors[i].message);
                            }
                        }
                    }
                });

            }
        }
    });
});
